<div class="login-container zd-gradient">
  <mat-card class="login-card">
    <mat-card-content>
      <div class="login-header">
        <img width="80" height="80" src="./assets/audittrail.png" alt="Audit Trail" class="login-logo" />
        <h2>Audit Trail</h2>
        <p class="login-subtitle">Sign in to view your audit data</p>
      </div>

      @if (errorReason.generalError && errorReason['generalErrorText'] === '') {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>An error has occurred contacting our servers. Please try again later.</span>
        </div>
      }
      @if (errorReason.generalError && errorReason['generalErrorText'] !== '') {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>{{ errorReason['generalErrorText'] }}</span>
        </div>
      }
      @if (errorReason.hasExpired) {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>The licence for {{ errorReason['orgName'] }} ({{ errorReason['serialNumber'] }}) expired on
            {{ errorReason.expires | date:dateTimeFormat }}.
            <a href="https://www.zeidman.info/contact/">Contact Zeidman Development</a> to renew.</span>
        </div>
      }
      @if (errorReason.noLicence) {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>You do not have a licence for this product.
            <a href="https://www.zeidman.info/contact/">Contact Zeidman Development</a> for more information.</span>
        </div>
      }
      @if (errorReason.accountLocked) {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>Your organisation account is currently locked.
            <a href="https://www.zeidman.info/contact/">Contact Zeidman Development</a> for more information.</span>
        </div>
      }
      @if (errorReason.noConfig) {
        <div class="error-banner">
          <mat-icon>error_outline</mat-icon>
          <span>We could not find an Audit Trail configuration for your account@if (errorReason.orgId) {<span> (organisation {{ errorReason.orgId }})</span>}.
            If Audit Trail has not been set up for your organisation yet, run the Audit Trail Configuration first.
            If you have been using Audit Trail already, please
            <a href="https://www.zeidman.info/contact/">contact Zeidman Development</a>@if (errorReason.orgId) {<span>, quoting the organisation number above</span>}.</span>
        </div>
      }

      <form #f="ngForm" novalidate (ngSubmit)="login(f)">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" required name="email" [ngModel]="credentials.email" #email="ngModel"
            [disabled]="isRequesting" autocomplete="email" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" required name="password" ngModel
            [disabled]="isRequesting" autocomplete="current-password" />
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" tabindex="-1">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>

        <button mat-raised-button type="submit" class="full-width login-button zd-button-gradient"
          [disabled]="f.invalid || isRequesting">
          @if (isRequesting) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Sign In
          }
        </button>
      </form>

      <div class="login-links">
        <a class="small-link" target="_blank" href="https://www.zeidman.info/reset-password/">Reset password?</a>
      </div>
    </mat-card-content>

    <div class="login-footer">
      <img src="./assets/zeidman_logo.jpg" alt="Zeidman Development" class="footer-logo" />
    </div>
  </mat-card>
</div>
